import { EmptyValuePlaceholder } from "@/components/ui"
import { SingleLineAddressOnListing } from '@/components/Address'
import { capitalize } from '@/utils/strings'
import { formatPrice, formatSurface} from '@/utils/formatters'

const BienItem = ({ bien }) => {
  const handleRowClick = (bienId) => {
    window.location.href = `/extranet/proprietaire/biens/${bienId}` // Rediriger vers la page de détails du bien cliqué
  }

  // Fonction pour obtenir les prix selon les mandats
  const getPrixByMandats = () => {
    if (!bien.mandats_data || bien.mandats_data.length === 0) {
      return <EmptyValuePlaceholder value={formatPrice(bien.prix_vente || bien.prix_loyer)}/>
    }

    if (bien.mandats_data.length === 1) {
      const mandat = bien.mandats_data[0]
      return <EmptyValuePlaceholder value={formatPrice(mandat.prix_vente || mandat.prix_loyer)}/>
    }

    // Cas de plusieurs mandats : afficher les deux prix
    return (
      <div className='flex flex-col'>
        {bien.mandats_data.map((mandat, i) => (
          <div key={i}>
            <EmptyValuePlaceholder value={formatPrice(mandat.prix_vente || mandat.prix_loyer)} />
          </div>
        ))}
      </div>
    )
  }

  // Fonction pour obtenir les honoraires selon les mandats
  const getHonorairesByMandats = () => {
    if (!bien.mandats_data || bien.mandats_data.length === 0) {
      return <EmptyValuePlaceholder value={formatPrice(bien.montant_honoraires_ttc)}/>
    }

    if (bien.mandats_data.length === 1) {
      const mandat = bien.mandats_data[0]
      return <EmptyValuePlaceholder value={formatPrice(mandat.montant_honoraires_ttc)}/>
    }

    // Cas de plusieurs mandats : afficher les deux honoraires
    return (
      <div className='flex flex-col'>
        {bien.mandats_data.map((mandat, i) => (
          <div key={i}>
            <EmptyValuePlaceholder value={formatPrice(mandat.montant_honoraires_ttc)}/>
          </div>
        ))}
      </div>
    )
  }

  return (
    <tr onClick={() => handleRowClick(bien.id)}
        data-object="bien" data-id={bien.id}
        className={`cursor-pointer hover:bg-primary-200 transition-all duration-500`}
    >
      <td>
        <div className={`flex items-center`}>
          { bien.type_mandats?.length < 2 && <EmptyValuePlaceholder value={bien.type_mandats[0]} className='capitalize'/>  }
          { bien.type_mandats?.length > 1 &&
              <div className='flex flex-col'>{
                bien.type_mandats.map((mandat, i) => <div key={i} className="capitalize">{mandat}</div>)
              }</div>
          }
        </div>
      </td>
      <td><EmptyValuePlaceholder value={getPrixByMandats()} /></td>
      <td><EmptyValuePlaceholder value={getHonorairesByMandats()} /></td>
      <td><EmptyValuePlaceholder value={formatPrice(bien.montant_gli)} /></td>
      <td>
        <SingleLineAddressOnListing data={bien} withApptNumber={false} />
        { bien.type_bien === "appartement" && bien.numero_appartement ? 
          <p>appt n° {bien.numero_appartement}</p> :
          null 
        }
      </td>
      <td><EmptyValuePlaceholder value={capitalize(bien.type_bien)} /></td>
      <td><EmptyValuePlaceholder value={formatSurface(bien.surface_carrez)} /></td>
      <td>{ Array.isArray(bien.locataires) 
        ? bien.locataires.map((loc, i) => <div key={i}>{loc.nom_complet}</div>) 
        : ""}
      </td>
    </tr>
  )
}

export default BienItem